/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const StartSocialLoginBody = zod.object({
  codeChallenge: zod.string().optional(),
  platform: zod.enum(['web', 'ios', 'android']),
  provider: zod.enum(['google', 'apple']),
  redirectUri: zod.string().min(1),
  state: zod.string().optional(),
});

export type StartSocialLoginBody = zod.input<typeof StartSocialLoginBody>;
export type StartSocialLoginBodyOutput = zod.output<typeof StartSocialLoginBody>;
